import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-conditions',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './terms-conditions.component.html',
  styleUrl: './terms-conditions.component.scss'
})
export class TermsConditionsComponent {

  constructor(public dialogRef: MatDialogRef<TermsConditionsComponent>) { }

}
